export default __webpack_public_path__ + "static/media/Cotidiano_favelado1.df719e7c.jpg";